<template>
  <div>
    <component :is="layoutComponentName">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
import DefaultLayout from "./layouts/DefaultLayout";
import ScanLayout from "./layouts/ScanLayout";

export default {
  name: "App",
  components: {
    DefaultLayout,
    ScanLayout,
  },
  computed: {
    layoutComponentName() {
      return this.$route.meta.layout || "DefaultLayout";
    },
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("auth/oidc/loadUser");
  },
};
</script>
